import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyUserSegmentation = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-user-segmentation", jiraSpaEntry: "async-user-segmentation" */ '@atlassian/jira-user-segmentation'
		),
	),
);

export const UserSegmentation = (): React.JSX.Element => (
	<LazyPage Page={LazyUserSegmentation} pageId="user-segmentation" shouldShowSpinner />
);
